(() => {
  const dialog = document.getElementById('design-preview');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const title = dialog.querySelector('h2');
  const status = dialog.querySelector('[data-preview-error]');
  const feedback = dialog.querySelector('[data-preview-feedback]');
  const addButton = dialog.querySelector('[data-preview-add]');
  const actions = dialog.querySelector('.design-preview-actions');
  const backgrounds = [...dialog.querySelectorAll('[data-preview-background]')];
  let trigger, controls, previewSvg, opening = 0;
  function setBackground(kind) {
    const selected = window.BDTFArtwork?.kind(kind) || 'light';
    window.BDTFArtwork?.apply(image.parentElement, selected);
    for (const button of backgrounds) button.setAttribute('aria-pressed', String(button.dataset.previewBackground === selected));
  }
  for (const button of backgrounds) {
    window.BDTFArtwork?.apply(button.querySelector('span'), button.dataset.previewBackground);
    button.addEventListener('click', () => setBackground(button.dataset.previewBackground));
  }
  function syncAdd() {
    const actionButton = controls?.buyButton || controls?.addButton;
    actions.hidden = !actionButton;
    if (!actionButton) return;
    addButton.textContent = actionButton.textContent;
    addButton.disabled = actionButton.disabled;
  }
  addButton.addEventListener('click', async () => {
    if (!controls || addButton.disabled) return;
    const source = controls, currentOpening = opening;
    feedback.hidden = true;
    // Reuse the card's selected size and destination: cart in the shop, sheet in the builder.
    const pending = source.buyButton ? source.buy() : source.add();
    syncAdd();
    await pending;
    if (!dialog.open || currentOpening !== opening) return;
    syncAdd();
    feedback.textContent = source.status.textContent;
    feedback.hidden = !feedback.textContent;
    if (document.activeElement === document.body && !addButton.disabled) addButton.focus({preventScroll:true});
  });
  image.addEventListener('load', () => {
    if(previewSvg)return;
    image.width = image.naturalWidth;
    image.height = image.naturalHeight;
    image.hidden = false;
    status.hidden = true;
  });
  image.addEventListener('error', () => { image.hidden = true; status.textContent = dialog.dataset.previewError; status.hidden = false; });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-design-preview]');
    if (!button || dialog.open) return;
    const thumbnail = button.querySelector('img');
    const croppedArtwork = button.querySelector('svg[data-preview-crop]');
    if (!thumbnail?.src && !croppedArtwork) return;
    previewSvg?.remove();previewSvg=null;
    trigger = button;
    opening++;
    const candidate = button.closest('.transfer-card, .transfer-pdp')?.querySelector('transfer-options');
    controls = typeof candidate?.add === 'function' ? candidate : null;
    syncAdd();
    feedback.hidden = true;
    title.textContent = button.dataset.designTitle || dialog.dataset.previewLabel;
    image.alt = title.textContent;
    image.style.background = 'transparent';
    setBackground(button.dataset.artworkBackground || button.closest('[data-artwork-background]')?.dataset.artworkBackground);
    image.hidden = true;
    status.hidden = true;
    dialog.showModal();
    if(croppedArtwork){
      image.removeAttribute('src');
      previewSvg=croppedArtwork.cloneNode(true);
      previewSvg.setAttribute('role','img');previewSvg.setAttribute('aria-label',title.textContent);previewSvg.removeAttribute('aria-hidden');
      image.parentElement.append(previewSvg);
      return;
    }
    image.src = thumbnail.currentSrc || thumbnail.src;
    if (image.complete && image.naturalWidth) image.hidden = false;
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  // Native modal-dialog focus containment includes the background and Add controls.
  dialog.addEventListener('close', () => { trigger?.focus({ preventScroll: true }); });
})();
